import { useState } from 'react';
import { originBase, shareLinkText } from '../events/util';

// REENVIAR UN LINK YA GENERADO.
//
// El link viaja por WhatsApp y ahí se pierde: con los mensajes temporales prendidos, a
// los dos días no lo tiene ni el RRPP ni el comprador. El panel sí lo tiene, pero hasta
// ahora solo se podía leer el código a mano. Generar otro link no es la salida: cada link
// cuenta como venta en la rendición.
//
// En el teléfono abre el menú de compartir del sistema; en la computadora copia el texto
// con el link y lo avisa.
export default function BotonCompartirLink({ link, event, compacto }) {
  const [copiado, setCopiado] = useState(false);
  const url = `${originBase()}/l/${link.code}`;

  async function compartir(e) {
    // La fila es clickeable (abre los asistentes): sin esto, compartir la abría o cerraba.
    e.stopPropagation();
    const text = shareLinkText({
      eventName: event?.name, eventDate: event?.date,
      cantidad: link.max_uses, lote: link.lot_name,
    });
    if (navigator.share) {
      try { await navigator.share({ title: event?.name || 'Entradas', text, url }); return; }
      catch (err) { /* cancelado: no es un error */ }
    }
    try {
      await navigator.clipboard?.writeText(`${text}\n${url}`);
      setCopiado(true); setTimeout(() => setCopiado(false), 1800);
    } catch {
      window.prompt('Copiá el link:', url);
    }
  }

  return (
    <span onClick={e => e.stopPropagation()}>
      <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={compartir} title="Compartir este link de nuevo">
        {copiado ? 'Copiado ✓' : (compacto ? 'Compartir' : 'Compartir ↗')}
      </button>
    </span>
  );
}
